export default {"src":"/_next/static/media/0x12f31B73D812C6Bb0d735a218c086d44D5fe5f89.b66aff12.svg","height":194,"width":194,"blurWidth":0,"blurHeight":0};